<script setup>
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';
    import axios from "../../../setup/axios";

    const { t } = useI18n();

    const props = defineProps({
        links: {
            type: Object,
            required: true,
        },

        index: {
            type: Number,
            required: true,
        },

        hasIcon: {
            type: Boolean,
            required: true,
            default: false,
        },

        showSecurityDialog: {
            type: Boolean,
            required: true,
            default: false,
        },

        showDistiInternalDialog: {
            type: Boolean,
            required: true,
            default: false,
        },

        assetName: {
            type: String,
            required: true,
            default: "",
        },

        productType: {
            type: String,
            required: true,
            default: "",
        },

        assetType: {
            type: String,
            required: true,
            default: "",
        },

        visibility: {
            type: String,
            required: true,
            default: "",
        },
    });

    const rightLinkHref = computed(() => {
        if(props.showSecurityDialog){
            return "#";
        } else {
            return props.links.url;
        }
    });

    const linkText = computed(() => {
        if( (props.productType == "ProductFamily" || props.productType == "MasterProduct" ) && props.links.language !== null && props.links.language !== "") {
            return 'Download (' + t('productHero.Download.Language.' + props.links.language) + ')';
        }
        else if (!props.hasIcon && props.links.language !== null && props.links.language !== ""){
            return t('productDetails.Download.Language.' + props.links.language.replaceAll("-","_"))
        }else {
            return t('productDetails.Download')
        }
    });

    const hasFileUrl = computed(() => {
        return props.links.url !== null && props.links.url !== undefined && props.links.url !== '';
    });

    function showPopup() {
        let currentPopup = document.getElementById(props.links.id);
        let $requestSecureButton = currentPopup.querySelector(".request.button");
        let $downloadSecureError = currentPopup.querySelector('.text-container.error');
        let $downloadSecurePending = currentPopup.querySelector('.text-container.pending-request');
        let $downloadSecureGranted = currentPopup.querySelector('.text-container.already-granted');
        let $downloadSecureText = currentPopup.querySelector('.text-container.normal');
        let $downloadSecureSuccess = currentPopup.querySelector('.text-container.success');
        let $downloadSecureButton = currentPopup.querySelector('.download.button');

        axios
            .get('/o/download-server/document-download/check-download/' + props.links.id)
            .then(response => {
                console.log('response : ' + response);
                if (response.status === 200 && response.data !== null && response.data !== undefined) {
                    if (!$requestSecureButton.classList.contains('is-hidden')) {
                        $requestSecureButton.classList.add('is-hidden');
                    }
                    if (!$downloadSecureSuccess.classList.contains('is-hidden')) {
                        $downloadSecureSuccess.classList.add('is-hidden');
                    }
                    if (!$downloadSecureText.classList.contains('is-hidden')) {
                        $downloadSecureText.classList.add('is-hidden');
                    }
                    if (!$downloadSecurePending.classList.contains('is-hidden')) {
                        $downloadSecurePending.classList.add('is-hidden');
                    }
                    if ($downloadSecureError.classList.contains('is-hidden')) {
                        $downloadSecureError.classList.add('is-hidden');
                    }
                    if ($downloadSecureGranted.classList.contains('is-hidden')) {
                        $downloadSecureGranted.classList.remove('is-hidden');
                    }
                    if ($downloadSecureButton.classList.contains('is-hidden')) {
                        $downloadSecureButton.classList.remove('is-hidden');
                    }
                }
            })
            .catch(error => {
                console.log('error : ' + error);
                if (
                    error !== null &&
                    error !== undefined &&
                    error.response !== null &&
                    error.response !== undefined &&
                    error.response.data !== null &&
                    error.response.data !== undefined &&
                    error.response.data.reason !== null &&
                    error.response.data.reason !== undefined &&
                    (error.response.data.reason === 'permission required' ||
                        error.response.data.reason === 'permission denied')
                ) {
                    if (error.response.data.reason === 'permission required') {
                        console.log('permission required');
                    } else if (error.response.data.reason === 'permission denied') {
                        if (!$requestSecureButton.classList.contains('is-hidden')) {
                            $requestSecureButton.classList.add('is-hidden');
                        }
                        if (!$downloadSecureSuccess.classList.contains('is-hidden')) {
                            $downloadSecureSuccess.classList.add('is-hidden');
                        }
                        if (!$downloadSecureText.classList.contains('is-hidden')) {
                            $downloadSecureText.classList.add('is-hidden');
                        }
                        if (!$downloadSecurePending.classList.contains('is-hidden')) {
                            $downloadSecurePending.classList.add('is-hidden');
                        }
                        if (!$downloadSecureGranted.classList.contains('is-hidden')) {
                            $downloadSecureGranted.classList.add('is-hidden');
                        }
                        if ($downloadSecureError.classList.contains('is-hidden')) {
                            $downloadSecureError.classList.remove('is-hidden');
                        }
                        if (!$downloadSecureButton.classList.contains('is-hidden')) {
                            $downloadSecureButton.classList.add('is-hidden');
                        }
                        console.log('permission denied');
                    }
                } else {
                    console.log('Other error : ' + error);
                }
            })
            .finally(() => {
                console.log('finally');

                document.getElementById(props.links.id).classList.remove("is-hidden");
                document.querySelector("section.product-downloads").classList.add("show-secure-dialog");
            });
    }

    function onRightLinkClick(event) {
        if(props.showSecurityDialog) {
            event.preventDefault();
            event.stopPropagation();

            showPopup();

        } else if(props.showDistiInternalDialog) {
            event.preventDefault();
            event.stopPropagation();

            let isInternal = event.currentTarget.closest(".download-container").classList.contains("has-internal-files");
            if(isInternal) {
                document.querySelectorAll(".internal-dialog-text").forEach($internalText => {
                    $internalText.classList.remove("hidden");
                });
                document.querySelectorAll(".disti-dialog-text").forEach($distiText => {
                    $distiText.classList.add("hidden");
                });
            } else {
                document.querySelectorAll(".internal-dialog-text").forEach($internalText => {
                    $internalText.classList.add("hidden");
                });
                document.querySelectorAll(".disti-dialog-text").forEach($distiText => {
                    $distiText.classList.remove("hidden");
                });
            }

            document.querySelector(".disti-download-popup").classList.remove("is-hidden");

            let $productDownloads = document.querySelector("section.product-downloads");

            if ($productDownloads.classList.contains('show-disti-dialog')) {
                $productDownloads.classList.remove('show-disti-dialog');
            } else {
                $productDownloads.classList.add('show-disti-dialog');
            }

            document.querySelector(".disti-accept").setAttribute("href", props.links.url);
        } else {
            if (window.dataLayer){
                dataLayer.push({
                    event: "download",
                    "download-name": JSON.stringify(props.assetName),
                    "download-type": JSON.stringify(props.assetType),
                });
            }
            return true;
        }
    }

    const hasLanguageClass = computed(() => {
        if(props.links.language !== null && props.links.language !== "") {
            return "has-language";
        }
    });

</script>

<template>
    <div class="link-container " :class="hasIcon ? 'has-icon' : '' ">
        <a v-if="hasFileUrl"
           :href="rightLinkHref"
           target="_blank"
           class="link "
           :class="hasLanguageClass"
            @click="onRightLinkClick($event)">

            {{ linkText }}
            <svg v-if="hasIcon" class="icon icon-download">
                <use xlink:href="#icon-download-2023"/>
            </svg>
        </a>
        <div v-if="!hasFileUrl" class="link " :class="hasLanguageClass">
            {{ linkText }}
            <svg v-if="hasIcon" class="icon icon-download">
                <use xlink:href="#icon-download-2023"/>
            </svg>
        </div>
    </div>
</template>
